import Dispatch from './shared/architecture/Dispatch'
import { map, filter, withLatestFrom } from 'rxjs/operators'

import _ from 'lodash'

const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit'

Dispatch.getAction('contact.send')
  .pipe(
    withLatestFrom(Dispatch.getState('Textbox.contact'))
  )
  .subscribe(([, contact]) => {
    // 'Request.contact' now only drives the submit button's loading state;
    // the old GraphQL request handler has been removed.
    Dispatch.nextAction('Request.contact', contact)

    fetch(WEB3FORMS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        access_key: process.env.REACT_APP_WEB3FORMS_KEY,
        subject: 'New message from the Inklink website',
        name: contact.name,
        email: contact.email,
        message: contact.message,
      }),
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          Dispatch.nextAction('Response.contact', { data: { contact: { success: true } } })
        } else {
          Dispatch.nextAction('Response.contact', { errors: [result.message || 'Contact request failed'] })
        }
      })
      .catch(error => Dispatch.nextAction('Response.contact', { errors: [error.message] }))
  })

Dispatch.getAction('Response.contact')
    .pipe(
      filter(e => _.isNil(e.errors)),
      map(e => e.data.contact.success),
      filter(e => e === true)
    )
  .subscribe(e => Dispatch.mergeState('Textbox.contact', {name: '', email: '', message: ''}))
